<template>
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>

    <div>
      <b-card>
        <!-- User Interface controls -->
        <b-row>
          <b-col md="2" class="my-0 ml-2">
            <b-form-input v-model="filter" placeholder="Filter"></b-form-input>
          </b-col>
          <b-col md="2" class="my-0 ml-2">
            <b-form-group class="my-1">
              <b-form-checkbox class="mx-3" v-model="filterShowActiveUsersOnly">Show active users only</b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col md="2" class="my-0 ml-2">
            <button class="btn btn-success" @click="addUser()">
              <i class="fa fa-plus-square" title="Add a new user"></i> <strong class="text-white">Add a new user</strong>
            </button>
          </b-col>
          <b-col cols="3" md="2" class="my-0 ml-2">
            <!-- Spacer column -->
          </b-col>
          <b-col md="2" class="my-0 ml-2">
            <button class="btn btn-info" @click="exportUserData()">
              <i class="fa fa-download" title="Export"></i> <strong class="text-white">Export User Data</strong>
            </button>
          </b-col>
        </b-row>
          <br />
          <!-- Main table element -->
          <b-table :items="FilteredRecords" :fields="gridfields" hover striped bordered small
                   :current-page="currentPage" :sort-compare="onNewSort" :per-page="perPage" show-empty>

            <template slot="created_ts" slot-scope="data">
              {{ data.item.created_ts | formatDate }}
            </template>

            <template slot="Actions" scope="data">
              <b-row>
                <b-col md="12" >
                  <div style="width:200px;">
                    <button class="btn btn-primary text-white" @click="openUserDetail(data.item.user_id)" style="min-width: 70px;">
                      <i class="fa fa-edit" title="Edit"></i> <strong class="text-white">Edit</strong>
                    </button>

                    <button v-if="!data.item.is_disabled" class="btn btn-warning text-white ml-1" @click="confirmDisable(data.item.user_id)" style="min-width: 70px;">
                      <i class="fa fa-toggle-off" title="Disable"></i> <strong class="text-white">Disable</strong>
                    </button>

                    <button v-if="data.item.is_disabled" class="btn btn-success text-white ml-1" @click="confirmEnable(data.item.user_id)" style="min-width: 70px;">
                      <i class="fa fa-toggle-on" title="Enable"></i> <strong class="text-white">Enable&nbsp;</strong>
                    </button>
                  </div>
                </b-col>
              </b-row>
            </template>

            <template slot="is_disabled" slot-scope="row">
              <input @click.stop type="checkbox" disabled v-model="row.value">
            </template>


          </b-table>
          <nav>
            <b-pagination :total-rows="getRowCount()" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" />
          </nav>
</b-card>
    </div>

    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>
import axios from 'axios'
import loading from 'vue-full-loading'
import moment from 'moment'
import cSwitch from '../components/Switch'

export default {
  components: {
    loading,
    cSwitch
  },
  created () {
    this.fetchData()
  },
  filters: {
    formatDate: function (date) {
      var m = moment(date)
      if (m.isValid()) {
        return m.add(moment().utcOffset(), 'm').format('MM/DD/YYYY hh:mm:ss a')
      }
      return ''
    },
    formatAccessDisplay: function (accessBool) {
      var display = 'No'
      if (accessBool) {
        display = 'Yes'
      }
      return display;
    }
  },
  data () {
    return {
      errMsg: '',
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      boolLoading: false,
      txtLoading: 'Loading...',
      users: [],
      filterShowActiveUsersOnly: true,
      totalCount: 0,
      tbxFilter: '',
      gridfields: [
        { key: 'name', label: 'Name', sortable: true },
        { key: 'login', label: 'Username', sortable: true },
        { key: 'email', label: 'Email', sortable: true },
        { key: 'apps', label: 'Apps', sortable: true },
        { key: 'is_disabled', label: 'Disabled', sortable: true },
        { key: 'created_ts', label: 'Created', sortable: true },
        { key: 'Actions', label: '', sortable: false }
      ],
      filter:'',
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      onNewSort (a, b, key) {
        if (['created_ts'].indexOf(key) !== -1) {
          switch (key) {
            // case 'FUTUREUNKNOW':
            //  console.log(`${JSON.stringify(new Date())} (typeof a) ${(typeof a[key])} [${JSON.stringify(a[key])}] (typeof a) ${(typeof a[key])} [${JSON.stringify(a[key])}]`);
            //  break;
            case 'created_ts':
              var a1 = moment(a[key])
              var b1 = moment(b[key])

              if (a1.isValid() && b1.isValid()) {
                if (a1.isSame(b1)) {
                  return 0
                }
                if (a1.isAfter(b1)) {
                  return 1
                }
                return -1
              } else {
                if (a1.isValid()) {
                  return 1
                }
                if (b1.isValid()) {
                  return -1
                }
              }
              return 0
          }
        } else {
          if (typeof a[key] === 'number' && typeof b[key] === 'number') {
            // If both compared fields are native numbers
            return a[key] < b[key] ? -1 : (a[key] > b[key] ? 1 : 0)
          } else if (typeof a[key] === 'boolean' && typeof b[key] === 'boolean') {
            let a1 = ((a[key] + '').toLowerCase().trim() === 'true') ? 1 : 0
            let b1 = ((b[key] + '').toLowerCase().trim() === 'true') ? 1 : 0
            return a1 < b1 ? 1 : (a1 > b1 ? -1 : 0)
          } else {
            let a1 = (a[key] + '')
            let b1 = (b[key] + '')
            return (a1).localeCompare(b1)
          }
        }
      }
    }
  },
  methods: {
    getRowCount () {
      return this.FilteredRecords.length
    },
    fetchData () {
      axios.get('/api/UserManagement/GetAll')
        .then(response => {
          this.boolLoading = false
          this.users = response.data.USERS
          this.totalCount = this.users.length
        })
        .catch(error => {
          if (error.response.status === 403) { this.$router.push('/login') }

          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    },
    addUser (p) {
      this.$router.push('/UserManagementDetail/-1')
    },
    openUserDetail (UserID) {
      this.$router.push('/UserManagementDetail/' + UserID)
    },
    confirmEnable (UserID) {
      var self = this

      self.$dialog.confirm('Are you sure you would like to enable user?')
        .then(function () {
          self.enableUser(UserID)
        })
        .catch(function () {

        })
    },
    confirmDisable (UserID) {
      var self = this

      self.$dialog.confirm('Are you sure you would like to disable user?')
        .then(function () {
          self.disableUser(UserID)
        })
        .catch(function () {
          // do nothing
        })
    },
    disableUser (UserID) {
      var self = this
      this.boolLoading = true
      var obj = {
        userId: UserID
      }

      axios.post('/api/UserManagement/Disable', obj)
        .then(response => {
          this.boolLoading = false

          let index = self.users.findIndex(x => x.user_id === UserID)
          self.users[index].is_disabled = true
        })
        .catch(error => {
          if (error.response.status === 403) { this.$router.push('/login') }

          this.boolLoading = false
          this.errMsg = 'There was an error deleting data : ' + error
          this.showDismissibleAlert = true
        })
    },
    enableUser (UserID) {
      var self = this
      this.boolLoading = true
      var obj = {
        userId: UserID
      }

      axios.post('/api/UserManagement/Enable', obj)
        .then(response => {
          this.boolLoading = false

          let index = self.users.findIndex(x => x.user_id === UserID)
          self.users[index].is_disabled = false
        })
        .catch(error => {
          if (error.response.status === 403) {
            self.$router.push('/login')
          }

          var newErrMsg = 'There was an error saving your changes : \n'
          if (error !== undefined && error.response !== undefined && error.response.statusText !== undefined) {
            newErrMsg = newErrMsg + error.response.statusText
          } else {
            newErrMsg = newErrMsg + error
          }

          alert(newErrMsg)
          self.fetchData()
        })
    },
    exportUserData () {
      let self = this
      self.boolLoading = true

      axios.get('/api/UserManagement/GetAllWithAppPermissions')
        .then(response => {
          this.boolLoading = false

          const a = document.createElement('a')
          a.style.display = 'none'
          document.body.appendChild(a)

          // Set the HREF to a Blob representation of the data to be downloaded
          let MIME_TYPE = 'text/csv'
          a.href = window.URL.createObjectURL(
            new Blob([response.data.ReportData], { type: MIME_TYPE })
          )

          // Use download attribute to set file name
          let fileName = new Date().toISOString() + '-UserPermissions.csv'
          a.setAttribute('download', fileName)

          // Trigger the download by simulating click
          a.click()

          // Cleanup
          window.URL.revokeObjectURL(a.href)
          document.body.removeChild(a)
        })
        .catch(error => {
          if (error.response.status === 403) { this.$router.push('/login') }

          this.boolLoading = false
          this.errMsg = 'There was an error getting export data : ' + error
          this.showDismissibleAlert = true
        })
    }
  },
  computed: {
    FilteredRecords: function () {
      if (this.boolLoading) {
        return []
      } else if (this.filter.length > 0) {
        return this.users.filter(u => u.is_disabled == !this.filterShowActiveUsersOnly)
          .filter(u => u.name.toLowerCase().includes(this.filter.toLowerCase())
          || u.login.toLowerCase().includes(this.filter.toLowerCase())
            || u.apps!=null && u.apps.toLowerCase().includes(this.filter.toLowerCase())
        )
      }
      else {
        return this.users.filter(u => u.is_disabled == !this.filterShowActiveUsersOnly);
      }
    }
  },
  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    this.boolLoading = true
  }
}
</script>

<style>
  .table > tbody > tr > td {
    /*vertical-align: middle;*/
  }

  .table-xtra-condensed > thead > tr > th,
  .table-xtra-condensed > tbody > tr > th,
  .table-xtra-condensed > tfoot > tr > th,
  .table-xtra-condensed > thead > tr > td,
  .table-xtra-condensed > tbody > tr > td,
  .table-xtra-condensed > tfoot > tr > td {
    padding: 2px;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/views/UserManagement.vue